import { render, staticRenderFns } from "./1_PersonalDetails.vue?vue&type=template&id=56702d24&"
import script from "./1_PersonalDetails.vue?vue&type=script&lang=js&"
export * from "./1_PersonalDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports